export const STAGES = [
  { key: "NEW", label: "Nuovo", color: "#64748B", icon: "🟢" },
  { key: "AUDIT", label: "Audit", color: "#8B5CF6", icon: "🔍" },
  { key: "CONTACTED", label: "Contattato", color: "#0EA5E9", icon: "🔵" },
  { key: "RESPONDED", label: "Risposto", color: "#06B6D4", icon: "💬" },
  { key: "QUALIFIED", label: "Qualificato", color: "#EAB308", icon: "🟡" },
  { key: "MEETING", label: "Appuntamento", color: "#F97316", icon: "🟠" },
  { key: "PROPOSAL", label: "Proposta", color: "#A855F7", icon: "🟣" },
  { key: "NEGOTIATION", label: "Trattativa", color: "#EC4899", icon: "🔴" },
  { key: "WON", label: "Acquisito", color: "#22C55E", icon: "✅" },
  { key: "LOST", label: "Perso", color: "#475569", icon: "⚫" },
];

export const stageMap = Object.fromEntries(STAGES.map((s) => [s.key, s]));

export const SERVICES = [
  "Social Media Management",
  "Foto/Video Production",
  "Social Strategy + Analysis",
  "Advertising",
  "Website",
  "Branding",
  "Event Strategy + Production",
  "Full Communication",
];

export const SECTORS = [
  "Ristorazione", "Hospitality", "Beauty", "Wellness", "Palestre",
  "Professionisti", "Automotive", "Retail", "Moda", "Immobiliari",
  "Locali", "Eventi", "B2B", "Artigiani", "Attività appena aperta", "Altro",
];

export const PRESENCE_FIELDS = [
  { key: "instagram", label: "Instagram" },
  { key: "facebook", label: "Facebook" },
  { key: "tiktok", label: "TikTok" },
  { key: "website", label: "Website" },
  { key: "google", label: "Google" },
  { key: "advertising", label: "Advertising" },
  { key: "branding", label: "Branding" },
  { key: "content", label: "Content" },
];

export const PRIORITY = {
  HOT: { label: "🔥 HOT", color: "#EF4444", bg: "rgba(239,68,68,0.12)" },
  HIGH: { label: "HIGH", color: "#F97316", bg: "rgba(249,115,22,0.12)" },
  MEDIUM: { label: "MEDIUM", color: "#EAB308", bg: "rgba(234,179,8,0.12)" },
  LOW: { label: "LOW", color: "#64748B", bg: "rgba(100,116,139,0.12)" },
};

export function eur(n) {
  const v = Number(n || 0);
  return "€" + v.toLocaleString("it-IT");
}

export const probColor = (v) => (v >= 60 ? "#22C55E" : v >= 35 ? "#EAB308" : "#EF4444");
